export default {
	isEnter(key: string) {
		return key === 'Enter';
	},
	isDelete(key: string) {
		return key === 'Delete';
	},
	isBackSpace(key: string) {
		return key === 'Backspace';
	},
	isArrowUp(key: string) {
		return key === 'ArrowUp';
	},
	isArrowDown(key: string) {
		return key === 'ArrowDown';
	},
	isArrowLeft(key: string) {
		return key === 'ArrowLeft';
	},
	isArrowRight(key: string) {
		return key === 'ArrowRight';
	},
	isEsc(key: string) {
		return key === 'Escape';
	},
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/keys.ts